'use client'

import { cn } from '@mntn-dev/ui-utilities'
import { Icon, type IconProps } from '../../icon/icon.tsx'
import { iconGlowMap } from '../../icon/index.ts'
import type { IconSize } from '../../icon/types/core.ts'
import {
  type SectionHeaderSize,
  useSectionHeaderContext,
} from './use-section-header.ts'

const sizeClassMap: Record<SectionHeaderSize, IconSize> = {
  sm: '2xl',
  md: '3xl',
  lg: '3xl',
}

export type SectionHeaderAccentProps = Partial<
  Pick<IconProps, 'fill' | 'name' | 'color'>
> & {
  className?: string
  glow?: boolean
}

export const SectionHeaderAccent = ({
  className,
  fill = 'outline',
  color = 'info',
  glow,
  name = 'ExclamationCircleIcon',
}: SectionHeaderAccentProps) => {
  const { size } = useSectionHeaderContext()

  const glowClassName =
    glow && iconGlowMap[color] ? iconGlowMap[color] : undefined

  return (
    <div className={glowClassName}>
      <Icon
        name={name}
        fill={fill}
        size={sizeClassMap[size]}
        color={color}
        className={cn(size === 'md' && 'h-14 w-14', className)}
      />
    </div>
  )
}
